import * as Restaumatic$dPrelude$dSpecular from "../Restaumatic.Prelude.Specular/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
const spinnerIconExtra = extraClass => Specular$dDom$dElement.el("span")([
  (node, cleanups) => {
    Specular$dDom$dElement.attr("aria-hidden")("true")(node, cleanups);
    return Specular$dDom$dElement.class_("icon-spinner icon-spin ")(node, cleanups);
  },
  Specular$dDom$dElement.class_(extraClass)
])(Restaumatic$dPrelude$dSpecular.wempty);
const spinnerIcon = /* #__PURE__ */ spinnerIconExtra("");
export {spinnerIcon, spinnerIconExtra};
